import {Model} from '../Models';
import {DataTransferObject} from './DataTransferObject';
import {PaymentInfoDTO} from './PaymentInfoDTO';

export class PayPalDTO extends PaymentInfoDTO {

  fromData(data: any): PayPalDTO {
    return new PayPalDTO();
  }

  validate(): boolean {
    return true;
  }

  validateField(field: string): boolean {
    return true;
  }

  fromModel(model: Model): DataTransferObject {
    throw new Error('Not implemented');
  }
}
